/**
 * queues
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 999.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */

import {HTTP} from '~/app.constants';
import {SmApiRequestsService} from './api-requests.service';

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import { ApiOptions }                        from './api';

import { Observable }                                        from 'rxjs';

import { QueuesAddOrUpdateMetadataRequest } from '../model/queues/queuesAddOrUpdateMetadataRequest';
import { QueuesAddOrUpdateMetadataResponse } from '../model/queues/queuesAddOrUpdateMetadataResponse';
import { QueuesAddTaskRequest } from '../model/queues/queuesAddTaskRequest';
import { QueuesAddTaskResponse } from '../model/queues/queuesAddTaskResponse';
import { QueuesClearQueueRequest } from '../model/queues/queuesClearQueueRequest';
import { QueuesClearQueueResponse } from '../model/queues/queuesClearQueueResponse';
import { QueuesCreateRequest } from '../model/queues/queuesCreateRequest';
import { QueuesCreateResponse } from '../model/queues/queuesCreateResponse';
import { QueuesDeleteMetadataRequest } from '../model/queues/queuesDeleteMetadataRequest';
import { QueuesDeleteMetadataResponse } from '../model/queues/queuesDeleteMetadataResponse';
import { QueuesDeleteRequest } from '../model/queues/queuesDeleteRequest';
import { QueuesDeleteResponse } from '../model/queues/queuesDeleteResponse';
import { QueuesGetAllExRequest } from '../model/queues/queuesGetAllExRequest';
import { QueuesGetAllExResponse } from '../model/queues/queuesGetAllExResponse';
import { QueuesGetAllRequest } from '../model/queues/queuesGetAllRequest';
import { QueuesGetAllResponse } from '../model/queues/queuesGetAllResponse';
import { QueuesGetByIdRequest } from '../model/queues/queuesGetByIdRequest';
import { QueuesGetByIdResponse } from '../model/queues/queuesGetByIdResponse';
import { QueuesGetDefaultResponse } from '../model/queues/queuesGetDefaultResponse';
import { QueuesGetNextTaskRequest } from '../model/queues/queuesGetNextTaskRequest';
import { QueuesGetNextTaskResponse } from '../model/queues/queuesGetNextTaskResponse';
import { QueuesGetNumEntriesRequest } from '../model/queues/queuesGetNumEntriesRequest';
import { QueuesGetNumEntriesResponse } from '../model/queues/queuesGetNumEntriesResponse';
import { QueuesGetQueueMetricsRequest } from '../model/queues/queuesGetQueueMetricsRequest';
import { QueuesGetQueueMetricsResponse } from '../model/queues/queuesGetQueueMetricsResponse';
import { QueuesMoveTaskBackwardRequest } from '../model/queues/queuesMoveTaskBackwardRequest';
import { QueuesMoveTaskBackwardResponse } from '../model/queues/queuesMoveTaskBackwardResponse';
import { QueuesMoveTaskForwardRequest } from '../model/queues/queuesMoveTaskForwardRequest';
import { QueuesMoveTaskForwardResponse } from '../model/queues/queuesMoveTaskForwardResponse';
import { QueuesMoveTaskToBackRequest } from '../model/queues/queuesMoveTaskToBackRequest';
import { QueuesMoveTaskToBackResponse } from '../model/queues/queuesMoveTaskToBackResponse';
import { QueuesMoveTaskToFrontRequest } from '../model/queues/queuesMoveTaskToFrontRequest';
import { QueuesMoveTaskToFrontResponse } from '../model/queues/queuesMoveTaskToFrontResponse';
import { QueuesMoveTaskToQueueRequest } from '../model/queues/queuesMoveTaskToQueueRequest';
import { QueuesMoveTaskToQueueResponse } from '../model/queues/queuesMoveTaskToQueueResponse';
import { QueuesPeekTaskRequest } from '../model/queues/queuesPeekTaskRequest';
import { QueuesPeekTaskResponse } from '../model/queues/queuesPeekTaskResponse';
import { QueuesRemoveTaskRequest } from '../model/queues/queuesRemoveTaskRequest';
import { QueuesRemoveTaskResponse } from '../model/queues/queuesRemoveTaskResponse';
import { QueuesUpdateRequest } from '../model/queues/queuesUpdateRequest';
import { QueuesUpdateResponse } from '../model/queues/queuesUpdateResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApiQueuesService {

    protected basePath = HTTP.API_BASE_URL;
    public defaultHeaders = new HttpHeaders({'Accept': 'application/json'});
    public configuration = new Configuration();

    constructor(protected apiRequest: SmApiRequestsService, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }



    /**
     * Add or update queue metadata
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesAddOrUpdateMetadata(request: QueuesAddOrUpdateMetadataRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesAddOrUpdateMetadataResponse>(`${this.basePath}/queues.add_or_update_metadata`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Adds a task entry to the queue.
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesAddTask(request: QueuesAddTaskRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesAddTaskResponse>(`${this.basePath}/queues.add_task`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Remove all tasks from the queue and change their statuses to what they were   prior to enqueuing or \&#39;created\&#39;
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesClearQueue(request: QueuesClearQueueRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesClearQueueResponse>(`${this.basePath}/queues.clear_queue`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Create a new queue
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesCreate(request: QueuesCreateRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesCreateResponse>(`${this.basePath}/queues.create`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Deletes a queue. If the queue is not empty and force is not set to true, queue   will not be deleted.
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesDelete(request: QueuesDeleteRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesDeleteResponse>(`${this.basePath}/queues.delete`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Delete metadata from queue
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesDeleteMetadata(request: QueuesDeleteMetadataRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesDeleteMetadataResponse>(`${this.basePath}/queues.delete_metadata`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Get all queues
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetAll(request: QueuesGetAllRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetAllResponse>(`${this.basePath}/queues.get_all`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Get all queues
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetAllEx(request: QueuesGetAllExRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetAllExResponse>(`${this.basePath}/queues.get_all_ex`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Gets queue information
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetById(request: QueuesGetByIdRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetByIdResponse>(`${this.basePath}/queues.get_by_id`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * 
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetDefault(request: object, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetDefaultResponse>(`${this.basePath}/queues.get_default`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Gets the next task from the top of the queue (FIFO). The task entry is removed   from the queue.
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetNextTask(request: QueuesGetNextTaskRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetNextTaskResponse>(`${this.basePath}/queues.get_next_task`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Get the number of task entries in the given queue
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetNumEntries(request: QueuesGetNumEntriesRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetNumEntriesResponse>(`${this.basePath}/queues.get_num_entries`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Returns metrics of the company queues. The metrics are avaraged in the   specified interval.
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesGetQueueMetrics(request: QueuesGetQueueMetricsRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesGetQueueMetricsResponse>(`${this.basePath}/queues.get_queue_metrics`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * 
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesMoveTaskBackward(request: QueuesMoveTaskBackwardRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesMoveTaskBackwardResponse>(`${this.basePath}/queues.move_task_backward`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Moves a task entry one step forward towards the top of the queue.
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesMoveTaskForward(request: QueuesMoveTaskForwardRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesMoveTaskForwardResponse>(`${this.basePath}/queues.move_task_forward`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * 
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesMoveTaskToBack(request: QueuesMoveTaskToBackRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesMoveTaskToBackResponse>(`${this.basePath}/queues.move_task_to_back`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * 
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesMoveTaskToFront(request: QueuesMoveTaskToFrontRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesMoveTaskToFrontResponse>(`${this.basePath}/queues.move_task_to_front`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Moves task to another queue
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesMoveTaskToQueue(request: QueuesMoveTaskToQueueRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesMoveTaskToQueueResponse>(`${this.basePath}/queues.move_task_to_queue`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Peek the next task from a given queue
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesPeekTask(request: QueuesPeekTaskRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesPeekTaskResponse>(`${this.basePath}/queues.peek_task`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Removes a task entry from the queue.
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesRemoveTask(request: QueuesRemoveTaskRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesRemoveTaskResponse>(`${this.basePath}/queues.remove_task`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

    /**
     * Update queue information
     * @param request request body
     * @param options flags and headers to use in webapp
     */
    public queuesUpdate(request: QueuesUpdateRequest, options?: ApiOptions): Observable<any> {
        return this.apiRequest.post<QueuesUpdateResponse>(`${this.basePath}/queues.update`,
            request,
            {
                headers: this.defaultHeaders,
                withCredentials: this.configuration.withCredentials
            },
            options
        );
    }

  }
